<template>
  <div id="main-content" class="detail-sub-driver">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.category') }}:</span>
            <span class="info-span"> {{ categoryInfo.name }} </span>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailBusNotificationCategory",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/bus-notification-template/category`,
        title: 'common.category_information'
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        bus_notification_category_id: this.$route.query.cid
      }
      this.$store.dispatch('busnotificationtemplate/getBusNotificationCategoryInfo', payload)
    },
    computed: {
      ...mapState('busnotificationtemplate', ['categoryInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/bus-notification-template/edit-category', query: {cid: this.$route.query.cid}});
      }
    }
  }
</script>

<style lang="scss">
</style>